// Funciones por atributo

// --------------------- ROLES --------------------- //

function generateNewRoles (tempConfigFile, lastRole, newRole) {
  // ROLES
  const newRoles = tempConfigFile.roles;
  for (let k = 0; k < newRoles.length; k++) {
    if (newRoles[k].name === lastRole.name) {
      newRoles[k].name = newRole.name;
      newRoles[k].permissions = newRole.permissions;
    }
  }

  return newRoles;
}

async function changeStagesWithNewRoles (tempConfigFile, lastRole, newRole) {
  // STAGES
  const newStages = tempConfigFile.stages.slice();
  for (let i = 0; i < newStages.length; i++) {
    newStages[i] = await changeRoles(newStages[i], lastRole, newRole);
  }

  return newStages;
}

async function changeRoles (inputObj, lastRole, newRole) {
  const outputObj = inputObj;
  if (outputObj.roles) {
    const found = outputObj.roles.findIndex(role => role === lastRole.name);
    if (found !== -1) {
      outputObj.roles[found] = newRole.name;
    }
  }

  // ONLY EXECUTED IN CASE OF SUBSTAGES
  if (outputObj.stages) {
    for (let i = 0; i < outputObj.stages.length; i++) {
      const found2 = outputObj.stages[i].roles.findIndex(
        role => role === lastRole.name
      );
      if (found2 !== -1) {
        outputObj.stages[i].roles[found2] = newRole.name;
      }
    }
    outputObj.stages = await changeRoles(outputObj.stages, lastRole, newRole);
  }
  return outputObj;
}

function changePermissionsWithNewRoles (tempConfigFile, lastRole, newRole) {
  // PERMISSIONS
  const newPermissions = tempConfigFile.permissions.slice();
  for (let k = 0; k < newPermissions.length; k++) {
    // In caser rolename has changed
    if (newPermissions[k].role === lastRole.name) {
      newPermissions[k].role = newRole.name;
    }
  }

  return newPermissions;
}

async function changeVisualizationRoles (inputObj, lastRole, newRole) {
  const outputObj = inputObj;
  const found = outputObj.visualizationRoles
    ? outputObj.visualizationRoles.findIndex(
      element => element === lastRole.name
    )
    : -1;

  if (found !== -1) {
    outputObj.visualizationRoles[found] = newRole.name;
  }

  if (outputObj.attributes && outputObj.attributes.length > 0) {
    for (let i = 0; i < outputObj.attributes.length; i++) {
      changeVisualizationRoles(outputObj.attributes[i], lastRole, newRole);
    }
  }

  if (
    outputObj.objSubtype &&
    outputObj.objSubtype.objects &&
    outputObj.objSubtype.objects.length > 0
  ) {
    for (let i = 0; i < outputObj.objSubtype.objects.length; i++) {
      changeVisualizationRoles(
        outputObj.objSubtype.objects[i],
        lastRole,
        newRole
      );
    }
  }

  return outputObj;
}

async function changeAssetTypesWithNewRoles (tempConfigFile, lastRole, newRole) {
  // ASSETTYPES
  const newAssetTypes = tempConfigFile.assetTypes.slice();
  changeVisualizationRoles(newAssetTypes, lastRole, newRole);
  for (let k = 0; k < newAssetTypes.length; k++) {
    newAssetTypes[k] = await changeVisualizationRoles(
      newAssetTypes[k],
      lastRole,
      newRole
    );
  }

  return newAssetTypes;
}

async function changeTransitionsWithNewRoles (
  tempConfigFile,
  lastRole,
  newRole
) {
  // TRANSISIONS
  const newTransitions = tempConfigFile.transitions.slice();
  for (let j = 0; j < newTransitions.length; j++) {
    newTransitions[j] = await changeRoles(newTransitions[j], lastRole, newRole);
  }

  return newTransitions;
}

// Devuelve el nuevo archivo de configuracion
export async function editRoleProcess (tempConfigFile, lastRole, newRole) {
  const newTempConfigFile = tempConfigFile;

  // Roles afecta a: 1) stages 2) Permissions 3) transitions 4) assetTypes -attributes - vsualizationROle

  newTempConfigFile.stages = await changeStagesWithNewRoles(
    tempConfigFile,
    lastRole,
    newRole
  );

  newTempConfigFile.permissions = await changePermissionsWithNewRoles(
    tempConfigFile,
    lastRole,
    newRole
  );
  newTempConfigFile.assetTypes = await changeAssetTypesWithNewRoles(
    tempConfigFile,
    lastRole,
    newRole
  );
  newTempConfigFile.transitions = await changeTransitionsWithNewRoles(
    tempConfigFile,
    lastRole,
    newRole
  );

  // Finally, edit ROLES

  newTempConfigFile.roles = await generateNewRoles(
    tempConfigFile,
    lastRole,
    newRole
  );

  return { ...newTempConfigFile };
}

// --------------------- Assets --------------------- //

export const generateSchemaAndUiSchema = (config, asset, isSubform) => {
  const actionProperties = asset.reduce(
    (acc, current) => {
      switch (current.type) {
        case 'string':
          acc.properties[current.attrName.toLowerCase()] = {
            type: 'string',
            title: current.title
          };
          acc.uiSchema[current.attrName.toLowerCase()] = Object.assign({
            'ui:field': isSubform ? 'customSubformTextInput' : 'customText',
            classNames: isSubform ? 'subObject' : 'custom-text-input'
          });
          break;
        case 'file':
          acc.properties[current.attrName.toLowerCase()] = {
            type: 'string',
            title: current.title
          };
          acc.uiSchema[current.attrName.toLowerCase()] = Object.assign({
            'ui:field': 'customFileHashInput',
            classNames: isSubform ? 'subObject' : 'custom-text-input'
          });
          break;
        case 'number':
          acc.properties[current.attrName.toLowerCase()] = {
            type: 'number',
            title: current.title
          };
          acc.uiSchema[current.attrName.toLowerCase()] = Object.assign({
            'ui:field': isSubform
              ? 'customSubformNumericInput'
              : 'customNumeric',
            classNames: isSubform ? 'subObject' : 'custom-numeric-input'
          });
          break;
        case 'boolean':
          acc.properties[current.attrName.toLowerCase()] = {
            type: 'boolean',
            title: current.title,
            default: false
          };
          acc.uiSchema[current.attrName.toLowerCase()] = Object.assign({
            'ui:field': 'Checkbox',
            classNames: isSubform ? 'subObject' : 'custom-boolean-input'
          });
          break;
        case 'date':
          acc.properties[current.attrName.toLowerCase()] = {
            type: 'string',
            title: current.title
          };
          acc.uiSchema[current.attrName.toLowerCase()] = Object.assign({
            'ui:field': 'DateInput',
            classNames: isSubform ? 'subObject' : 'custom-date-input'
          });
          break;
        case 'array':
          acc.properties[current.attrName.toLowerCase()] = {
            type: 'string',
            title: current.title,
            enum: [' ', current.listValue].flat(),
            default: ' ',
            enumNames: ['Elija una opción', current.listValue].flat()
          };
          acc.uiSchema[current.attrName.toLowerCase()] = Object.assign({
            'ui:field': isSubform
              ? 'customSubformSelectInput'
              : 'customSelect',
            classNames: isSubform ? 'subObject' : 'custom-select-input'
          });
          break;
        case 'asset': {
          const additionalSchema = generateSchemaAndUiSchema(
            config,
            config.assetTypes.find(
              assetType => assetType.id === current.assetType
            ).attributes,
            true
          );
          additionalSchema.properties.assetType = {
            title: 'Asset ID',
            default: current.assetType,
            type: 'string'
          };
          additionalSchema.uiSchema.assetType = {
            'ui:widget': 'hidden'
          };
          acc.properties.assets = {
            type: 'array',
            title: current.title,
            items: {
              type: 'object',
              properties: additionalSchema.properties
            }
          };

          acc.uiSchema.assets = {
            items: additionalSchema.uiSchema
          };
          break;
        }
        case 'object':
          acc.properties[current.attrName.toLowerCase()] = {
            type: 'object',
            title: current.title
          };
          if (current.objSubtype && current.objSubtype.objects.length > 0) {
            const additionalSchema = generateSchemaAndUiSchema(
              config,
              current.objSubtype.objects,
              true
            );
            acc.properties[
              current.attrName.toLowerCase()
            ].properties = Object.assign(additionalSchema.properties);
            acc.uiSchema[current.attrName.toLowerCase()] = Object.assign(
              additionalSchema.uiSchema
            );
          }
          break;
        case 'stringArray':
          acc.properties[current.attrName.toLowerCase()] = {
            type: 'array',
            title: current.title,
            items: { type: 'string' }
          };
          acc.uiSchema[current.attrName.toLowerCase()] = Object.assign({
            'ui:field': 'TextInputWithTags',
            classNames: 'custom-tag-input'
          });
          break;
        default:
          break;
      }
      return acc;
    },
    { properties: {}, uiSchema: {} }
  );
  return actionProperties;
};

export async function changeActionsAndTransitionsFromAsset (
  configFile,
  formData
) {
  const newConfigFile = configFile;
  for (let i = 0; i < configFile.actions.length; i++) {
    const item = newConfigFile.actions[i];
    if (item.assetType === formData.id) {
      const newSchema = generateSchemaAndUiSchema(
        configFile,
        formData.attributes
      );

      newConfigFile.actions[i].schema.properties = newSchema.properties;
      newConfigFile.actions[i].uiSchema = newSchema.uiSchema;

      newConfigFile.transitions &&
        newConfigFile.transitions.forEach((transition, keyTransition) => {
          transition.actions &&
            transition.actions.forEach((transitionAction, keyAction) => {
              if (transitionAction.schema.assetType === formData.id) {
                newConfigFile.transitions[keyTransition].actions[
                  keyAction
                ].schema.properties = newSchema.properties;
                newConfigFile.transitions[keyTransition].actions[
                  keyAction
                ].uiSchema = newSchema.uiSchema;
              }
            });
        });
    }
  }
  return newConfigFile;
}

export async function editAssetsProcess (tempConfigFile, newAssetData) {
  let newTempConfigFile = tempConfigFile;
  newTempConfigFile = await changeActionsAndTransitionsFromAsset(
    tempConfigFile,
    newAssetData
  );

  const index = newTempConfigFile.assetTypes.findIndex(
    assetType => assetType.id === newAssetData.id
  );
  newTempConfigFile.assetTypes[index] = newAssetData;

  return { ...newTempConfigFile };
}

// --------------------- Actions --------------------- //

function generateAction (tempConfigFile, formData) {
  const asset = tempConfigFile.assetTypes.find(
    type => type.id === formData.asset
  );
  const actionProperties = generateSchemaAndUiSchema(
    tempConfigFile,
    asset.attributes,
    false
  );
  const action = {
    id: formData.id,
    name: formData.name,
    description: formData.description,
    assetType: asset.id,
    schema: {
      title: formData.formAssetTitle,
      type: 'object',
      properties: actionProperties.properties
    },
    uiSchema: actionProperties.uiSchema,
    actionRef: {
      method: formData.type,
      name: 'apiSigneBlock-asset-service-STAGE-asset',
      path: '/asset'
    },
    mandatory: true
  };
  return action;
}

export function editActionsWithNewData (tempConfigFile, newAction) {
  const newTempConfigFile = tempConfigFile;

  tempConfigFile.transitions.forEach((transition, keyTransition) => {
    transition.actions.forEach((action, keyAction) => {
      if (action.id === newAction.id) {
        newTempConfigFile.transitions[keyTransition].actions[
          keyAction
        ] = generateAction(tempConfigFile, newAction);
      } else {
        newTempConfigFile.transitions[keyTransition].actions[
          keyAction
        ] = action;
      }
    });
  });

  newTempConfigFile.actions = tempConfigFile.actions.map(action =>
    action.id === newAction.id
      ? generateAction(tempConfigFile, newAction)
      : action
  );

  return { ...newTempConfigFile };
}

// --------------------- Builer --------------------- //

export function editBuilderProcess (
  tempConfigFile,
  subStageId,
  newSubstageName
) {
  const newTempConfigFile = tempConfigFile;

  newTempConfigFile.stages.forEach(stage => {
    stage.stages.forEach(subStages => {
      if (subStageId === subStages.id) {
        subStages.name = newSubstageName;
      }
    });
  });

  return { ...newTempConfigFile };
}
